import React, { Component } from "react";
import MessageAlert from "./MessageAlert";
import { messageTypes } from "./MessageAlert";
import LocalizationUtil from "../../../localization/LocalizationUtil";
import { messages } from "../../../localization/messages";
import { constants } from "../../../utils/Constants";
const HttpStatus = require("http-status-codes");

class MessageAlertContainer extends Component {
  constructor(props) {
    super(props);
    this.state = { message: null, messageType: messageTypes.BASIC_MESSAGE };
  }

  _showMessage = (message, messageType) => {
    this.dismissAlert();

    if (message.error) {
      console.log(message.error);
    }

    try {
      const text = message.text;
      var responseMessage =
        text && typeof text === "object" ? text : JSON.parse(message.text);
      responseMessage = LocalizationUtil.getLocalizedText(responseMessage);
      message.text = responseMessage;
    } catch (parseError) {
      //do nothing, 500 Server Error will be shown
      console.log(parseError);
    }

    if (message.status && message.statusText === "") {
      message.statusText = HttpStatus.getStatusText(message.status);
    }

    if (
      (message.text === undefined || message.text === "") &&
      messageType === messageTypes.ERROR_MESSAGE
    ) {
      message.text = messages.clientError;
      message.code = constants.CLIENT_ERROR_CODE;
    }

    this.setState({ message: message, messageType: messageType });

    setTimeout(this.dismissAlert, 5000);
  };

  showSuccessMessage = message => {
    this._showMessage(message, messageTypes.SUCCESS_MESSAGE);
  };

  showWarningMessage = message => {
    this._showMessage(message, messageTypes.WARNING_MESSAGE);
  };

  showErrorMessage = message => {
    this._showMessage(message, messageTypes.ERROR_MESSAGE);
  };

  dismissAlert = () => {
    this.setState({ message: null, messageType: messageTypes.BASIC_MESSAGE });
  };

  render() {
    return (
      <MessageAlert
        message={this.state.message}
        messageType={this.state.messageType}
        onDismiss={this.dismissAlert}
        className={this.props.className}
        desktopClassName={this.props.desktopClassName}
        mobileClassName={this.props.mobileClassName}
      />
    );
  }
}

export default MessageAlertContainer;
